import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { InfoIcon } from '../../../components/Icons/Icons'
import { formatMoney } from '../../../utils/amount'
import { formatPercent } from './helpers'

const ACCENT_CLASSES = {
  default: '',
  success: 'bg-success-light/40 border-success-main/30',
  error: 'bg-error-light/40 border-error-main/30',
  info: 'bg-info-light/40 border-info-main/30',
}

const VALUE_CLASSES = {
  default: 'text-text-primary',
  success: 'text-success-main',
  error: 'text-error-main',
  info: 'text-info-main',
}

const KpiCard = ({ label, value, sublabel, accent = 'default', tooltip }) => (
  <div
    className={`flex-1 min-w-[190px] rounded-2xl border border-divider bg-paper p-5 ${ACCENT_CLASSES[accent] || ''}`}
    data-testid={`kpi-card-${label}`}
  >
    <div className="flex items-center gap-1.5">
      <p className="text-sm text-text-secondary font-medium">{label}</p>
      {tooltip && (
        <Tooltip title={tooltip} arrow placement="top">
          <span className="inline-flex cursor-help" aria-label={`${label} info`}>
            <InfoIcon fill="var(--color-gray-500)" />
          </span>
        </Tooltip>
      )}
    </div>
    <p className={`text-2xl font-semibold mt-2 ${VALUE_CLASSES[accent] || VALUE_CLASSES.default}`}>{value}</p>
    <p className="text-xs text-text-secondary mt-1">{sublabel}</p>
  </div>
)

const safeCount = (value) => (typeof value === 'number' ? value : '—')

const KpiCards = ({ kpis = {} }) => {
  return (
    <div className="flex flex-wrap gap-4">
      <KpiCard label="Payments Today" value={safeCount(kpis.paymentsToday)} sublabel="Total scheduled" />
      <KpiCard
        label="Total to Process"
        value={typeof kpis.totalToProcess === 'number' ? formatMoney(kpis.totalToProcess) : '—'}
        sublabel="Total amount"
      />
      <KpiCard
        label="Ready to Process"
        value={safeCount(kpis.readyToProcess)}
        sublabel="No issues"
        accent="success"
      />
      <KpiCard
        label="Previously Bounced"
        value={safeCount(kpis.previouslyBounced)}
        sublabel="Needs review"
        accent="error"
      />
      <KpiCard
        label="AI Forecasted Success Rate"
        value={formatPercent(kpis.aiForecastedSuccessRate)}
        sublabel="Across today's payments"
        accent="info"
        tooltip="Heuristic based on each client's historical payment success — not a prediction model."
      />
    </div>
  )
}

export default KpiCards
